import { Component, OnInit } from '@angular/core';
import { AppState, MediaActionTypes, selectProfile } from '@app/core/ngrx';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { Media, User } from '@app/core/models';
/**
 * HelpCenterComponent
 */
@Component({
  selector: 'ecp-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss'],
})
export class HelpCenterComponent implements OnInit {
  /**
   * loading$
   */
  isNewsletter = true;
  isResource = false;
  isProgram = false;
  isTab4 = false;
  isTab5 = false;
  isTab6 = false;

  // @select(['media', 'pending'])
  loading$: Observable<boolean>;
  // @select(['user', 'profile'])
  user$: Observable<User>;
  /**
   * media$
   */
  // @select(['media', 'list'])
  media$: Observable<Media>;
  /**
   * constructor
   */
  constructor(private store: Store<AppState>) {}
  /**
   * ngOnInit
   */
  ngOnInit() {
    this.loading$ = this.store.pipe(select(state => state.media.pending));
    this.user$ = this.store.pipe(select(selectProfile));
    // we need to get the VisionWeb token from the user's profile
    this.user$.subscribe(user => {
      // once we have the token we can call the other services
      if (user.token) {
        window.localStorage.setItem('token', user.token);
        this.store.dispatch({ type: MediaActionTypes.LOAD_MEDIA });
      }
    });
  }

  showSelectedMedia(value) {
    window.console.log(value);
    if (value === 'Newsletter') {
      this.isNewsletter = true;
      this.isResource = false;
      this.isProgram = false;
      this.isTab4 = false;
      this.isTab5 = false;
      this.isTab6 = false;
    } else if (value === 'Resources') {
      this.isNewsletter = false;
      this.isResource = true;
      this.isProgram = false;
      this.isTab4 = false;
      this.isTab5 = false;
      this.isTab6 = false;
    } else if (value === 'Program Overview') {
      this.isNewsletter = false;
      this.isResource = false;
      this.isProgram = true;
      this.isTab4 = false;
      this.isTab5 = false;
      this.isTab6 = false;
    } else if (value === 'Tab4') {
      this.isNewsletter = false;
      this.isResource = false;
      this.isProgram = false;
      this.isTab4 = true;
      this.isTab5 = false;
      this.isTab6 = false;
    } else if (value === 'Tab5') {
      this.isNewsletter = false;
      this.isResource = false;
      this.isProgram = false;
      this.isTab4 = false;
      this.isTab5 = true;
      this.isTab6 = false;
    } else {
      this.isNewsletter = false;
      this.isResource = false;
      this.isProgram = false;
      this.isTab4 = false;
      this.isTab5 = false;
      this.isTab6 = true;
    }
  }
}
